import { AlertsJurisdictionModel } from "../models/alerts-jurisdiction";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-jurisdiction.html");

const dom = {
    SLIDER: ".slider",
    JURISDICTION_ENABLED: ".jurisdiction-enabled input"
};

@backboneViewProperties({
    tagName: "tr",
    template
})
@autoinject
export class AlertsJurisdictionView extends Marionette.ItemView<AlertsJurisdictionModel> {

    private template: string;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SLIDER] = (e) => this.sliderClick(e);
        return events;
    }

    private sliderClick(e: JQueryEventObject) {
        this.model.Enabled = !this.model.Enabled;
        this.saveAlert();
    }

    private saveAlert() {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "Jurisdiction", Value: this.model.Jurisdiction, Enabled: this.model.Enabled});

        this.model.saveAlert().then(() => {
            this.$(dom.JURISDICTION_ENABLED).prop("checked", this.model.Enabled);
            this.$(dom.JURISDICTION_ENABLED).val("" + this.model.Enabled);
            this.appEvents.trigger(AppEvents.InformationMessage, "The alert for " + this.model.Jurisdiction + " has been " + (this.model.Enabled ? "Enabled" : "Disabled"));
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.Jurisdiction);
            this.RevertCheckbox();
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.Jurisdiction);
            this.RevertCheckbox();
        });
    }

    private RevertCheckbox() {
        this.model.Enabled = !this.model.Enabled;
        this.$(dom.SLIDER).prop("checked", this.model.Enabled);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-jurisdiction.ts